module.exports = __webpack_public_path__ + "static/img/p8.bf32352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p8.png
// module id = yx7c
// module chunks = 0